import { useEffect, useMemo } from 'react';
import { useTranslations } from '@altermaind/core/i18n';
import { TutorialDialog } from '@/_shared/components/TutorialDialog/TutorialDialog';
import { TutorialKeys } from '@/_shared/constants';
import { useTutorialCheck } from '@/_shared/hooks';
import { useDialog } from '@/_shared/hooks/useDialog';
import { getEmployeesMeCall } from '@/profile/state/api';

export const Tutorial = () => {
  const t = useTranslations('assessments.tutorial');
  const { hasManagerLeader, hasTeamLeader } = getEmployeesMeCall.hook();

  const { openDialog: openDialogAssessmentTutorial, isOpen } = useDialog('assessmentTutorial');
  const { hasAlreadySeenTutorial } = useTutorialCheck();

  const slides = useMemo(() => {
    if (hasTeamLeader) {
      return [
        {
          title: t('team.slides.slide1.title'),
          description: t('team.slides.slide1.description'),
          assetName: 'tutorialAssessmentTeamSlide1',
        },
        {
          title: t('team.slides.slide2.title'),
          description: t('team.slides.slide2.description'),
          assetName: 'tutorialAssessmentTeamSlide2',
        },
      ];
    }
    if (hasManagerLeader) {
      return [
        {
          title: t('manager.slides.slide1.title'),
          description: t('manager.slides.slide1.description'),
          assetName: 'tutorialAssessmentManagerSlide1',
        },
        {
          title: t('manager.slides.slide2.title'),
          description: t('manager.slides.slide2.description'),
          assetName: 'tutorialAssessmentManagerSlide2',
        },
      ];
    }
    return [
      {
        title: t('employee.slides.slide1.title'),
        description: t('employee.slides.slide1.description'),
        assetName: 'tutorialAssessmentEmployeeSlide1',
      },
      {
        title: t('employee.slides.slide2.title'),
        description: t('employee.slides.slide2.description'),
        assetName: 'tutorialAssessmentEmployeeSlide2',
      },
    ];
  }, [hasManagerLeader, hasTeamLeader, t]);

  const translationsKey = useMemo(() => {
    if (hasTeamLeader) {
      return 'assessments.tutorial.team';
    }
    if (hasManagerLeader) {
      return 'assessments.tutorial.manager';
    }
    return 'assessments.tutorial.employee';
  }, [hasManagerLeader, hasTeamLeader]);

  useEffect(() => {
    if (!hasAlreadySeenTutorial(TutorialKeys.Assessment)) {
      openDialogAssessmentTutorial();
    }
  }, [hasAlreadySeenTutorial, openDialogAssessmentTutorial]);

  return (
    <TutorialDialog
      translationsKey={translationsKey}
      dialogKey='assessmentTutorial'
      slides={slides}
      isOpenProp={isOpen}
    />
  );
};
